module.exports = __webpack_public_path__ + "img/catFoodLogo_2023.bcff4823.png";